import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from "vue-router";
import App from './App.vue';
import routes from "./routes/routes";
import Antd from 'ant-design-vue';
import {isAuthenticated} from "./models/User";
import 'ant-design-vue/dist/antd.css';
import GlobalComponents from "./globalComponents";

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import VueTheMask from 'vue-the-mask';

const router = new VueRouter({
  mode: 'history', routes
});

function kitNumberParameter() {
  let url_string = window.location.href;
  let url = new URL(url_string);
  let kit = url.searchParams.get("kit_number");
  return (!!kit) ? kit : false;
}

function hasCarePlan() {
  return store.state.user && store.state.user.care_plan;
}

function dateAditionalZero(number) {
  return (number <= 9) ? "0" + number : number;
}

router.beforeEach((to, from, next) => {
  if (to.name === 'home' && isAuthenticated()) next({name: 'kits'});
  if (to.name === 'profile' && !isAuthenticated()) next({name: 'home'}); else if (to.name === 'cadastrar_kit' && !isAuthenticated() && kitNumberParameter()) next({
    name: 'home', query: {kit_number: kitNumberParameter()}
  }); else if (to.name === 'cadastrar_kit' && !isAuthenticated()) next({name: 'home'}); else if (to.name === 'dashboard' && !isAuthenticated()) next({name: 'home'}); else if (to.name === 'kits' && !isAuthenticated()) next({name: 'home'}); else if (to.name === 'results' && !isAuthenticated()) next({name: 'home'}); else if (to.name === 'returns' && !isAuthenticated()) next({name: 'home'}); else if (to.name === 'schedules' && !isAuthenticated()) next({name: 'home'}); else if (to.name === 'healthid-digital' && !isAuthenticated()) next({name: 'home'}); else if (to.name === 'care-plan' && (!isAuthenticated() || !hasCarePlan())) next({name: 'home'}); else next()
});

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(GlobalComponents);

/**
 * REDUX STORE INSTANTIABLE
 */
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: null
  }, mutations: {
    setUser(state, newState) {
      state.user = newState;
    }
  }
});

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueTheMask);
Vue.use(Antd);
Vue.mixin({
  methods: {
    dateParse: function (date) {
      date = new Date(date);
      date = (dateAditionalZero(date.getDate())) + "/" + ((dateAditionalZero(date.getMonth() + 1))) + "/" + date.getFullYear();
      return date;
    },
  },
});
new Vue({
  el: '#app', render: h => h(App), router, store
});



// WEBPACK FOOTER //
// ./src/index.js